import { Component, Inject } from '@angular/core';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISelection } from 'pbc.types';

import { ITemplatesQueryShapes, TemplatesQueryFilterConfig } from 'fa-kt.types';
import { TemplatesService } from '../service';

@Component({
  selector: 'fa-kt-templates-filter',
  templateUrl: './templates-filter.component.html',
  styleUrls: ['./templates-filter.component.css'],
})
export class TemplatesFilterComponent {
  readonly subscriptions: Subscription[] = [];

  TemplatesFilterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public templates: TemplatesService,
  ) {
    this.TemplatesFilterConfig = TemplatesQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push(
      this.templates.shapes$.subscribe((shapes: ITemplatesQueryShapes | undefined) => {
        if (!shapes) {
          return;
        }
        Object.entries(shapes)
          .filter(([key]) => key !== 'id' && (shapes as any)[key])
          .forEach(([key]) => this.shape(key, (shapes as any)[key]));
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.TemplatesFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.TemplatesFilterConfig[index].selections = shapes;
  }
}
